import { createContext } from "preact";
import { useMemo, useState } from "preact/hooks";

export const DayContext = createContext({
    date: {day: null, setDay: () => {}},
    backup: {using: false, setUsing: () => {}},
    debug: false,
    disable: () => false
})

export default function EventProvider(props) {

    const [day, setDay] = useState(props.day || null)
    const [bkp, setBkp] = useState(props.backup || false)
    const [debug, setDebug] = useState(props.debug || false)

    const debugDate = useMemo(() => {
		return { day, setDay };
	}, [day]);

    const bkpMemo = useMemo(() => {
		return { using: bkp, setUsing: setBkp };
	}, [bkp]);

    return <DayContext.Provider value={{
        date: debugDate,
        backup: bkpMemo,
        debug: debug,
        disable: () => setDebug(false)
    }}>
        {props.children}
    </DayContext.Provider>

}